"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldView = exports.MAX_STRING_LENGTH = void 0;
var input_1 = require("../../../components/input/input");
var input_state_1 = require("../../../components/input/input.state");
var input_style_1 = require("../../../components/input/input.style");
var mithril_1 = require("../../../mithril");
exports.MAX_STRING_LENGTH = 40;
function getRowsNumber(value) {
    var rows = input_1.MIN_NUMBER_ROWS;
    var lines = value.split('\n');
    if (lines.length > input_1.MIN_NUMBER_ROWS) {
        rows = 0;
        lines.forEach(function (line) { return rows += getRowsNumber(line); });
    }
    else if (value.length > exports.MAX_STRING_LENGTH) {
        rows = Math.ceil(value.length / exports.MAX_STRING_LENGTH);
    }
    return rows;
}
exports.TextFieldView = {
    viewInline: function (field) {
        var value = field.value;
        var rows = getRowsNumber(value);
        if (rows === input_1.MIN_NUMBER_ROWS) {
            return field.displayValue;
        }
        else {
            var classList = [
                input_style_1.CSS.container,
                input_style_1.CSS.MDL.container,
                input_style_1.CSS.isCompact
            ];
            var className = classList.join(' ');
            var attrs = {
                className: input_style_1.CSS.input + ' ' + input_style_1.CSS.MDL.input,
                rows: rows,
                value: value,
                title: value,
                disabled: true,
                style: { resize: 'none', overflow: 'hidden', outline: 'none' }
            };
            var children = [
                (0, mithril_1.m)('textarea', attrs)
            ];
            return (0, mithril_1.m)('div', { className: className }, children);
        }
    },
    canGeocoding: function (field) {
        var metadata = field.collection.schema.metadata;
        if (metadata.options.address_lookup) {
            if (field.schema.id === metadata.options.address_lookup.address.field) {
                return true;
            }
        }
        return false;
    },
    viewDetail: function (field) {
        return null;
    },
    viewEdit: function (field, ctrl) {
        var inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new input_state_1.InputState(field.schema.displayName);
            inputState.onValue(function () { return field.Mutator.manual(inputState.value); });
            inputState.setValue(field.value);
            ctrl.changeState.addState(field.id, inputState);
        }
        var value = inputState.value;
        var rows = getRowsNumber(value);
        return input_1.Input.view(inputState, { rows: rows });
    },
    hasClear: function (field) {
        return false;
    }
};
//# sourceMappingURL=text.field.view.js.map